module.exports = __webpack_public_path__ + "media/images/project/assignee_circle-b529be5eda7500870355927b3152b31c.svg";